import type { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'

import { FeatureFlagKeys } from '@hapana/shared/constants/feature-flag.constants'
import { useAwaitedFeatureFlag } from '_hooks/use-awaited-feature-flag.hooks'

import { ROUTES } from '../../../app.constants'

type FamilySettingsRouteGuardProps = {
  children: ReactElement
}

const FamilySettingsRouteGuard = ({ children }: FamilySettingsRouteGuardProps) => {
  const isEnabled = useAwaitedFeatureFlag(FeatureFlagKeys.FamilyAccountsEnabled)
  if (isEnabled === null) {
    return null
  }
  if (!isEnabled) {
    return <Navigate to={`/c/${ROUTES.controlCenter.path}`} replace />
  }
  return children
}

export default FamilySettingsRouteGuard
